export default __webpack_public_path__ + "static/media/Magnifier.837d00cf.svg";